import React from 'react'

const Footer = () => {
  return (
    <div className="flex mt-24 mb-24 justify-center items-center">
      <p className="dark:text-gray-200 text-xl text-gray-600 text-center m-20">
        © 2022 All rights reserved by Shoppy.com
      </p>
      </div>
  )
}

export default Footer